import {
  CloseButton,
  Dialog,
  Flex,
  Heading,
  Portal,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { LuPackage } from "react-icons/lu";

import ExpandableSearchButton from "@components/common/ExpandableSearchButton";
import {
  cargoItemFootprint,
  footprintFormatters,
} from "helpers/pricingUnit";
import type { ContainerPricingUnit } from "helpers/pricingUnit";
import type { CargoItem } from "@features/services/shipping/types";

interface CargoListModalProps {
  open: boolean;
  onClose: () => void;
  pricingUnit: ContainerPricingUnit;
  items: CargoItem[];
}

const CargoListModal = ({
  open,
  onClose,
  pricingUnit,
  items,
}: CargoListModalProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const fmt = footprintFormatters(pricingUnit);

  const query = searchQuery.trim().toLowerCase();
  const filteredItems =
    query === ""
      ? items
      : items.filter((item) => item.description.toLowerCase().includes(query));

  return (
    <Dialog.Root open={open} onOpenChange={onClose} lazyMount size="md">
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bgColor="surface.background" p={6}>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>

            <Flex align="center" justify="space-between" mb={4}>
              <Heading fontSize="lg">Cargo List</Heading>
            </Flex>
            <Flex direction="column" gap={2}>
              <Flex justify="flex-end">
                <ExpandableSearchButton
                  query={searchQuery}
                  setQuery={setSearchQuery}
                />
              </Flex>
              {items.length > 0 && filteredItems.length === 0 && (
                <Text fontSize="sm" color="text.secondary" py={2} px={3}>
                  No items matching &ldquo;{searchQuery.trim()}&rdquo;.
                </Text>
              )}
              {filteredItems.map((item) => (
                <Flex
                  key={item.id}
                  align="center"
                  justify="space-between"
                  py={2}
                  px={3}
                  bg="surface.muted"
                  borderRadius="md"
                >
                  <Flex align="center" gap={2} minW={0}>
                    <Flex flexShrink={0}>
                      <LuPackage size={14} />
                    </Flex>
                    <Text fontSize="sm" fontWeight="medium">
                      {item.description}
                    </Text>
                  </Flex>
                  <Text fontSize="sm" color="fg.muted" flexShrink={0} ml={3}>
                    {fmt.formatItemDisplay(
                      cargoItemFootprint(item, pricingUnit),
                    )}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default CargoListModal;
